import { REQUIRED_PLACEHOLDERS } from "@panel/shared/contract/misc/constants";

export const TRIPARTITE_COPY = {
    title       : "Tripartite Agreement",
    description : (brandName) => `Upload the agreement once for ${brandName || "this brand"}, then send it to its publishers — all at once or one by one. Each publisher's contract is signed in order: you, then the brand, then the publisher.`,
    placeholders: `The PDF must contain ${REQUIRED_PLACEHOLDERS.join(", ")} as selectable text. Each is filled in as that party signs; your name is filled in when you send it.`,
    empty       : "No agreement uploaded yet.",
    upload      : "Upload Tripartite Agreement",
    uploading   : "Uploading…",
    awaitUpload : "Upload the agreement first",
    noPublishers: "No publishers linked to this brand yet.",
    saved       : "Contract saved. Send it to publishers when you are ready.",
    saveFailure : "Could not save the contract. Please try again."
};

// What the Time column says for a row, by where its contract stands.
export const PUBLISHER_TIME_COPY = {
    signed : "Signed",
    sent   : "Sent",
    notSent: "Not sent yet"
};

export const SEND_COPY = {
    all            : "Send to all",
    one            : "Send",
    sending        : "Sending…",
    // Nobody is left who has not been sent this version.
    allSent        : "Every publisher has been sent this version",
    allConfirmTitle: "Send the agreement to all publishers?",
    allConfirmText : "Every active publisher of this brand who has not been sent this version receives their contract. This cannot be undone.",
    oneConfirmTitle: (name) => `Send the agreement to ${name}?`,
    oneConfirmText : "They receive their contract once the brand has signed it. This cannot be undone.",
    confirmButton  : "Send contract",
    // `queued` / `already_sent` / `failed` from the send response.
    result         : ({ queued = 0, already_sent: alreadySent = 0, failed = 0 }) => [
        `${queued} queued for sending`,
        alreadySent ? `${alreadySent} already sent` : "",
        failed ? `${failed} failed — send again` : ""
    ].filter(Boolean).join(" · "),
    failure: "Could not send the agreement. Please try again."
};

export const RETRY_COPY = {
    button : "Retry stuck",
    tooltip: "Re-queues contracts that have been sending or signing for more than 10 minutes",
    // `retried_sends` / `retried_brand_signs` / `failed` from the retry response.
    // Nothing re-queued means nothing has been stuck for 10 minutes yet.
    result : ({ retried_sends: sends = 0, retried_brand_signs: signs = 0, failed = 0 }) => (sends + signs + failed ? [
        sends ? `${sends} send${sends === 1 ? "" : "s"} re-queued` : "",
        signs ? `${signs} brand sign${signs === 1 ? "" : "s"} re-queued` : "",
        failed ? `${failed} failed — try again` : ""
    ].filter(Boolean).join(" · ") : "Nothing has been stuck long enough to retry yet"),
    failure: "Could not retry. Please try again."
};

// "3 of 8 publishers have signed."
export const signedSummary = ({ signed = 0, total = 0 }) => `${signed} of ${total} publisher${total === 1 ? "" : "s"} have signed.`;
